export const ARBEIDSGIVER_MAX_LENGDE = 120;
export const STILLINGSTITTEL_MAX_LENGDE = 40;